import { t } from '~/i18n';
import { BillingRow } from './useBillingBreakdown';
import { deviceTypeLabel, profileGroup, profileTypeLabel, rowTypeLabel } from './billingLabels';

const escapeCsv = (value: string | number): string => {
  const text = String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// Build a CSV mirroring the table: Type, Name, profile columns, device columns.
export function buildBillingCsv(
  rows: BillingRow[],
  deviceTypes: string[],
  profileTypes: string[]
): string {
  const header = [
    t('billing.table.type'),
    t('billing.table.name'),
    ...profileTypes.map(profileTypeLabel),
    ...deviceTypes.map(deviceTypeLabel),
  ];

  const lines = rows.map((row) => {
    const profileCount = (group: string) =>
      row.usage.profiles.items
        .filter((item) => profileGroup(item.profileType) === group)
        .reduce((sum, item) => sum + item.count, 0);
    const deviceCount = (type: string) =>
      row.usage.devices.items.find((item) => item.deviceType === type)?.count ?? 0;
    return [
      rowTypeLabel(row.kind),
      row.name,
      ...profileTypes.map(profileCount),
      ...deviceTypes.map(deviceCount),
    ];
  });

  return [header, ...lines].map((cols) => cols.map(escapeCsv).join(',')).join('\n');
}
